module.exports = "<router-outlet></router-outlet>\r\n<app-spinny></app-spinny>"